import { Pipe, PipeTransform } from '@angular/core';
import {FileService} from "../../routes/jy-content/attachment/service/file.service";
/**
 * 排序使用
 * key：排序关键词
 * order: asc/desc 升序降序
 */
@Pipe({ name: 'attachmentSrc' })
export class AttachmentSrcPipe implements PipeTransform {

  constructor(private fileService: FileService) {

  }

  transform(key: string): string {
    if (key) {
      return this.fileService.getDownloadFileFullUrl(key);
    }
    return key;
  }
}
